import { render, staticRenderFns } from "./DesktopSortingSelect.vue?vue&type=template&id=d4fbca24&"
import script from "./DesktopSortingSelect.vue?vue&type=script&lang=js&"
export * from "./DesktopSortingSelect.vue?vue&type=script&lang=js&"
import style0 from "./DesktopSortingSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports